import { MenuItem } from '@/core/models';
import { MenuItemValidatorUtil } from '../utils';

export class CartTotalQuantityRule {
	/**
	 * Total de menu items agregados al carrito.
	 */
	public static calculate(menuItems: MenuItem[] | null | undefined): number {
		return (
			menuItems?.reduce((acc, item) => {
				if (!this.isValid(item)) return acc;

				return acc + Number(item?.cantidad ?? 0);
			}, 0) ?? 0
		);
	}

	/**
	 * Validaciones de los menu items antes de calcular
	 */
	private static isValid(menuItem: MenuItem): boolean {
		return MenuItemValidatorUtil.isValid(menuItem);
	}
}
